<template>
  <div class="fts-module-connector-design">
    <div :class="containerClass">
      <!-- type -->
      <div :class="connectorTypeClass">
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'type',
            icon: 'fts-icon-menu-caret-down',
          }"
          comfort-design
          class="tt-123"
        >
          <fts-select
            slot="formElement"
            slot-scope="{ formData, item, onInput, onBlur }"
            :form-data="formData"
            :item="item"
            :options="connectorTypes"
            comfort-design
            @input="(val) => connectorTypeOnInput(val, onInput)"
            @search:blur="onBlur"
          >
            <div
              slot="selected-option-container"
              slot-scope="{ option }"
              class="md-connector-app"
            >
              <div class="md-connector-app-icon" v-if="option.logo">
                <img :src="option.logo">
              </div>
              <div class="md-connector-app-name">
                {{option.name}}
              </div>
            </div>
            <div
              slot="option"
              slot-scope="{ option }"
              class="md-connector-app"
            >
              <div class="md-connector-app-icon" v-if="option.logo">
                <img :src="option.logo">
              </div>
              <div class="md-connector-app-name">
                {{option.name}}
              </div>
            </div>
          </fts-select>
        </fts-form-element>
      </div>
      <!-- form -->
      <template v-for="x in form">
        <!-- input mask -->
        <div
          :key="`${formData.type}-${x.id}`"
          :class="formItemClass"
          v-if="x.input === 'inputMask'"
        >
          <fts-form-element
            :form-data="formData"
            :item="x"
            :validator="validator"
            comfort-design
            :masked="formData[x.fieldName] === true"
          />
        </div>
        <!-- default -->
        <div
          :key="`${formData.type}-${x.id}`"
          :class="formItemClass"
          v-else
        >
          <fts-form-element
            :form-data="formData"
            :item="x"
            :validator="validator"
            comfort-design
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import FTSFormElement from "../elements/FTSFormElement";
import FTSSelect from "../elements/FTSSelect";
/* scss */
import "../../assets/scss/module-design.scss";

export default {
  components: {
    "fts-form-element": FTSFormElement,
    "fts-select": FTSSelect,
  },
  props: {
    value: Object,
    validator: Object,
    containerClass: String,
    connectorTypes: Array,
    connectorTypeClass: String,
    form: Array,
    formItemClass: String,
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  methods: {
    connectorTypeOnInput(val, onInput) {
      onInput();
      if (val) {
        this.$emit("updateValue", { type: val});
      } else {
        this.$emit("updateValue", {});
      }
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('updateValue', val);
      }
    },
  },
}
</script>